

    <div class="main-wrapper">
      <img style="float: right;color: black;padding: 10px;" src="/assets/icons/close-light.svg" class="close" (click)="close()">
      
      <div   style="text-align: center;margin-top: -7px;
      margin-bottom: -14px;">
      <h2>{{ dialogData.title }}</h2>
      </div>
      <table style=" padding: 10px; padding-bottom: 15px;">
          <tr>
            <td>
              <!-- <mat-dialog-content> -->
                <p [innerHTML]="dialogData.message"></p>
                <p [innerHTML]="dialogData.message2"></p>
                <p [innerHTML]="dialogData.message3"></p>
                <p [innerHTML]="dialogData.message4"></p>
              <!-- </mat-dialog-content> -->
          </td>
          </tr>
        </table>
  </div>
  